module.exports = "/_next/static/files/51455b11fad99794ba044a3e8a9f5018.png";